import {
  fetchPublisherApiKeys,
  createPublisherApiKey,
  revokePublisherApiKey,
} from '../../shared/utils/api';
import {
  FETCH_API_KEYS_REQUEST,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_FAIL,
  CREATE_API_KEY_REQUEST,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_FAIL,
  REVOKE_API_KEY_REQUEST,
  REVOKE_API_KEY_SUCCESS,
  REVOKE_API_KEY_FAIL,
  CLEAR_NEWLY_CREATED_KEY,
} from '../../store/types';
import { UI_MESSAGES } from '../../shared/constants';
import { extractContractError } from '@bafkal/ui-shared/utils';

export const fetchApiKeys = () => async (dispatch) => {
  dispatch({ type: FETCH_API_KEYS_REQUEST });
  try {
    const data = await fetchPublisherApiKeys();
    dispatch({ type: FETCH_API_KEYS_SUCCESS, payload: data });
    return data;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.API_KEYS.FETCH_FAILED);
    dispatch({ type: FETCH_API_KEYS_FAIL, payload: contractError });
    throw err;
  }
};

export const createApiKey = (name) => async (dispatch) => {
  dispatch({ type: CREATE_API_KEY_REQUEST });
  try {
    const data = await createPublisherApiKey(name);
    dispatch({ type: CREATE_API_KEY_SUCCESS, payload: data });
    return data;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.API_KEYS.CREATE_FAILED);
    dispatch({ type: CREATE_API_KEY_FAIL, payload: contractError });
    throw err;
  }
};

export const revokeApiKey = (id) => async (dispatch) => {
  dispatch({ type: REVOKE_API_KEY_REQUEST });
  try {
    await revokePublisherApiKey(id);
    dispatch({ type: REVOKE_API_KEY_SUCCESS, payload: id });
    return id;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.API_KEYS.REVOKE_FAILED);
    dispatch({ type: REVOKE_API_KEY_FAIL, payload: contractError });
    throw err;
  }
};

export const clearNewlyCreatedKey = () => ({
  type: CLEAR_NEWLY_CREATED_KEY,
});
